var _path, _path2, _rect, _g, _rect2, _rect3, _g2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCni2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 308,
    viewBox: "0 0 507 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91284 20.1142C4.91284 11.2146 12.4698 4 21.7919 4H485.121C494.443 4 502 11.2146 502 20.1142V287.61C502 296.51 494.443 303.724 485.121 303.724H21.7919C12.4698 303.724 4.91284 296.51 4.91284 287.61V20.1142Z",
    fill: "#E8EFFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7919 15.5844H485.121C487.877 15.5844 489.957 17.6952 489.957 20.1142V287.61C489.957 290.029 487.877 292.14 485.121 292.14H21.7919C19.0365 292.14 16.9561 290.029 16.9561 287.61V20.1142C16.9561 17.6952 19.0365 15.5844 21.7919 15.5844ZM21.7919 2.08413C11.4964 2.08413 2.99697 10.0737 2.99697 20.1142V287.61C2.99697 297.651 11.4964 305.64 21.7919 305.64H485.121C495.417 305.64 503.916 297.651 503.916 287.61V20.1142C503.916 10.0737 495.417 2.08413 485.121 2.08413H21.7919Z",
    fill: "white",
    stroke: "#E8EFFB",
    strokeWidth: 3.83174
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 416.762,
    y: 24.1423,
    width: 60.7645,
    height: 22.5599,
    rx: 4,
    fill: "#171C60"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2025_5389)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.3884,
    y: 24.1421,
    width: 60.7645,
    height: 22.5599,
    fill: "#171C60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.5862,
    y: 24.1421,
    width: 18.5669,
    height: 22.5599,
    fill: "#FF5326"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6418,
    y: 24.1421,
    width: 21.9427,
    height: 22.5599,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.095,
    y: 24.1423,
    width: 269.22,
    height: 22.5599,
    rx: 4,
    fill: "#A3BBDC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 112.095,
    y: 50.7307,
    width: 269.22,
    height: 8.05711,
    rx: 4,
    fill: "#A3BBDC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 200.5,
    y: 156,
    width: 157,
    height: 20,
    rx: 4,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 199.5,
    y: 182,
    width: 157,
    height: 19,
    rx: 4,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 200.5,
    y: 207,
    width: 156,
    height: 20,
    rx: 4,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 200.5,
    y: 233,
    width: 156,
    height: 19,
    rx: 4,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 369.502,
    y: 233.085,
    width: 98.7423,
    height: 19.3371,
    rx: 4,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 200.5,
    y: 80,
    width: 94,
    height: 19,
    rx: 4,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 199.5,
    y: 120,
    width: 157,
    height: 20,
    rx: 4,
    fill: "#A3BBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 370,
    y: 260.544,
    width: 86.083,
    height: 11.28,
    rx: 4,
    fill: "#A3BBDC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.307 241.963L103.298 241.97C102.824 242.318 102.357 242.662 101.899 243C101.44 242.662 100.973 242.318 100.499 241.97L100.49 241.963C97.2529 239.581 93.6631 236.939 89.8661 233.967C97.535 229.315 105.524 223.684 113.258 216.719L114.321 215.761C121.426 209.461 128.6 202.024 135.031 192.935C146.939 176.106 156.587 153.085 156.42 120.599L156.412 119.072L154.934 118.689C135.892 113.75 113.126 111.754 101.957 111.424L101.899 111.422L101.84 111.424C90.6714 111.754 67.9057 113.75 48.863 118.689L47.3851 119.072L47.3772 120.599C47.2105 153.085 56.8584 176.106 68.7662 192.935C73.8073 200.059 79.3045 206.168 84.8669 211.511C80.801 214.295 76.7325 216.76 72.7374 218.984C51.0779 197.447 29.8881 163.991 33.5373 109.26C56.3992 101.119 88.3715 98.3563 101.879 98.0005L101.899 98L101.918 98.0005C115.425 98.3563 147.398 101.119 170.26 109.26C173.065 151.333 161.193 180.798 145.769 201.932C135.001 216.686 122.461 227.436 111.823 235.601C108.802 237.92 105.939 240.027 103.307 241.963Z",
    fill: "#1956A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.625 179.467C76.625 166.295 87.3033 155.616 100.476 155.616C113.648 155.616 124.326 166.295 124.326 179.467V181.375H76.625V179.467Z",
    fill: "#1956A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.484 139.244C112.484 146.006 107.002 151.487 100.24 151.487C93.4782 151.487 87.9966 146.006 87.9966 139.244C87.9966 132.482 93.4782 127 100.24 127C107.002 127 112.484 132.482 112.484 139.244Z",
    fill: "#1956A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2025_5389"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.3884,
    y: 24.1421,
    width: 60.7647,
    height: 22.5599,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCni2);
export default __webpack_public_path__ + "static/media/CNI_2.cb9de735a1a6f7be56b26427cef29ca5.svg";
export { ForwardRef as ReactComponent };